export default __webpack_public_path__ + "static/media/dv_4.a937d02f.svg";